





























































































import { Component, Prop, Vue } from "vue-property-decorator";

import IconSearched from "@/components/icons/IconSearched.vue";
import { Table as CatalogTable } from "@/components/organisms/Table";

import SearchLine from "./blocks/SearchLine.vue";
import FilterLink from "./blocks/FilterLink.vue";

import { ITableRow } from "@/components/organisms/Table/interfaces";
import { View } from "@/components/organisms/Table/enums";

import { calcMarginPrice, copy, qSet } from "@/services/utils";

import {
  catalogModule,
  commonModule,
  pricesModule,
} from "@/plugins/store-accessors";
import { SortDirections } from "@/store/catalog/enums";
import { defaultFilters, defaultHeaders } from "./mocks";
import IconRefresh from "@/components/icons/IconRefresh.vue";
import { IProduct } from "@/services/interfaces";

@Component({
  name: "catalog",
  components: {
    IconRefresh,
    SearchLine,
    CatalogTable,
    IconSearched,
    FilterLink,
  },
})
export default class ProductList extends Vue {
  tableViewType: View = View.table;
  tableHeaders = defaultHeaders;

  @Prop({ type: Number, default: 0 })
  readonly total!: number;

  @Prop({ type: Boolean, default: false })
  readonly saleFilterDisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly promoFilterDisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly availableFilterDisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly topFilterDisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly fetching!: boolean;

  @Prop({ type: String, default: "" })
  readonly search!: string;

  @Prop({ type: Function, default: () => null })
  readonly afterOrder!: () => void;

  get products() {
    return catalogModule.getProducts;
  }

  get getMeta() {
    return catalogModule.getMeta;
  }

  get currentDataPrice() {
    return pricesModule.getCurrentData;
  }

  get productWithTypePrice() {
    const currentDataPrice = this.currentDataPrice;
    if (currentDataPrice) {
      return this.products.map((el: IProduct) => ({
        ...el,
        price: calcMarginPrice(
          Number(el.price),
          currentDataPrice.margin,
          currentDataPrice.rounding,
        ),
        promo_price: !!el.promo_price
          ? calcMarginPrice(
              Number(el.promo_price),
              currentDataPrice.margin,
              currentDataPrice.rounding,
            )
          : undefined,
      }));
    }
    return this.products;
  }

  get sortBy() {
    return this.$route.query.sort;
  }

  get sortDirection() {
    return this.$route.query.order;
  }

  get searchQuery() {
    return this.$route.query.q;
  }

  get saleDisabled() {
    if (this.isSalePage) {
      return false;
    }
    return this.saleFilterDisabled;
  }

  get isSalePage() {
    return this.$route.path.includes("sale");
  }

  get hideSaleCheckBox() {
    return (
      this.$route.path.includes("promo") ||
      this.$route.path.includes("sale") ||
      this.$route.path.includes("top")
    );
  }

  get isNotification() {
    return this.getMeta.notification;
  }

  get getQuantity() {
    return catalogModule.getQuantity;
  }

  get rows(): ITableRow[] {
    return [
      ...this.addTypeProp(catalogModule.getUpperCategories, "upperCategory"),
      ...this.addTypeProp(catalogModule.getCategories, "category"),
      ...this.addTypeProp(this.productWithTypePrice, "product"),
    ];
  }

  get activeFilter() {
    const route = this.$route.query;
    let filter = false;
    defaultFilters.forEach((item) => {
      if (route[item.code] === "true") {
        filter = true;
      }
    });

    return filter;
  }

  refreshFilters() {
    const query = { ...this.$route.query };
    defaultFilters.forEach((item) => {
      delete query[item.code];
    });

    this.$router.push({ query: query });
  }

  changeQuantity(pl: { id: number; val: number }) {
    return catalogModule.changeQuantity(pl);
  }

  changeSort(name: string) {
    const query = copy(this.$route.query);
    let order,
      sort: string | undefined = name;
    if (query.sort && query.sort === name) {
      switch (query.order) {
        case SortDirections.ASC:
          order = SortDirections.DESC;
          break;
        case SortDirections.DESC:
          sort = undefined;
          order = undefined;
          break;
        default:
          order = SortDirections.ASC;
          break;
      }
    } else {
      order = SortDirections.ASC;
    }
    let QUERY = qSet("sort", sort, query);
    QUERY = qSet("order", order, QUERY);
    QUERY = qSet("page", null, QUERY);
    this.$router.replace({
      path: this.$route.path,
      query: QUERY,
    });
  }

  setType(view: View) {
    this.tableViewType = view;
    localStorage.setItem("viewType", view);
  }

  getSlug(row?: ITableRow) {
    if (!row) {
      return "";
    }
    return row.slug || row.id;
  }

  getContext() {
    switch (this.$route.name) {
      case "sale":
      case "sale-detail":
        return "sale";
      case "sale-new":
        return "sale/new";
      case "promo-detail":
      case "promo":
        return "promo";
      case "top-detail":
      case "top":
        return "top";
      default:
        return "catalog";
    }
  }

  rowClickHandler(row: ITableRow, index: number) {
    const context = this.getContext();
    const query = { ...this.$route.query };
    delete query.page;

    if (row.type === "category") {
      this.$router.push({
        path: `/${context}/${this.getSlug(row)}/`,
        query: query,
      });
    } else if (row.type === "upperCategory") {
      const slug = this.getSlug(this.rows[index - 1]);
      if (slug) {
        this.$router.push({
          path: `/${context}/${slug}/`,
          query: query,
        });
      } else {
        this.$router.push({
          path: `/${context}/`,
          query: query,
        });
      }
    }
  }

  addTypeProp(rows: ITableRow[], type: string): ITableRow[] {
    return rows.map((row: ITableRow, index: number): ITableRow => {
      return { ...row, type, index } as ITableRow;
    });
  }

  mounted() {
    const type = localStorage.getItem("viewType") as View;
    if (type) {
      this.tableViewType = type;
    }
  }
}
